import React, { useContext, useEffect, useState, useRef } from "react";
import { Container, Row, Col, Button, Card, Accordion, Modal as BsModal, Toast } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import Rating from "@mui/material/Rating";
import CircularProgress from "@mui/material/CircularProgress";
import { Star, Verified, LocalOffer, School, Group, SignalCellularAlt, HourglassTop, CardMembership } from "@mui/icons-material";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import dateFormat from "dateformat"

import GetCourseDetails from "../../actions/GetCourseDetails";
import RegisterCourse from "../../actions/RegisterCourse";
import LoginStatus from "../../actions/LoginStatus";
import SaveUserEvent from "../../actions/SaveUserEvent";
import DetectDevice from "../../data/DetectDevice";
import PriceFormat from "../../actions/PriceFormat";
import SetPage from "../../data/SetPage";

import { AuthContext } from "../../context/AuthContext";
import SyllabusAccordion from "./SyllabusAccordion";
import FeaturesList from "./FeaturesList";
import Reviews2 from "../reviews/Reviews2";
import ContactSection from "../../components/ContactSection";
import LearnIntern from "../../components/LearnIntern";
import SuccessStories from "../home/SuccessStories";
import CourseDetailsLoadingTemplate from "../../templates/CourseDetailsLoadingTemplate";
import Borderline from "../../../src/assets/images/borderline.png"
import divider from "../../assets/bg/divider.png";
import { GroupIcon } from "lucide-react";
import { orange } from "@mui/material/colors";
import Placements from "../../components/updatehackinginternship/HackingPlacements";
import HackingReview from "../../components/updatehackinginternship/HackingReview";


const CourseDetails1 = () => {
  const { user } = useContext(AuthContext);
  const params = useParams();
  const course_url = params.course_url;
  const mode = params.mode;

  const featuressection = useRef();
  const overviewsection = useRef();
  const certificatesection = useRef();
  const reviewssection = useRef();
  const syllabussection = useRef();
  const projectssection = useRef();
  const contactsection = useRef();

  const [course, setcourse] = useState(null);
  const [projects, setprojects] = useState(null);
  const [chapters, setchapters] = useState(null);
  const [enrolled, setenrolled] = useState(false);
  const [registering, setregistering] = useState(false);
  const [toast, settoast] = useState(false);
  const [tm, settm] = useState(null);
  const [tt, settt] = useState(null);
  const logoBlue = '#00A1E4';
  const logoOrange = '#F28C38';
  const borderRadius = '2rem';
  const shadow = '0 8px 32px 0 rgba(31, 38, 135, 0.37)';
  const device = DetectDevice();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [course_url, mode]);

  useEffect(() => {
    SetPage("Course details");
    GetCourse();
  }, [course_url]);

  const GetCourse = async () => {
    const res = await GetCourseDetails(course_url, mode, user);
    if (res.status === "success") {
      setcourse(res.course[0]);
      setprojects(res.projects);
      setchapters(res.chapters);
      setenrolled(res.enrolled);
    }
  };

  const NewRegisterCourse = async () => {
    setregistering(true);
    sessionStorage.setItem("redirect", "/course/" + course_url + "/" + mode);

    settt("Registering !");
    settm("Please wait for a while...");
    settoast(true);

    const loginstatus = LoginStatus();
    if (loginstatus === true) {
      const res = await RegisterCourse({
        payload: {
          user: user.SessionId,
          course_url: course_url,
          mode: mode,
        },
      });

      setregistering(false);

      if (res && res[0] && res[0].status === "success" && res[0].enrollment === "pending") {

        if (mode === "free") {
          window.location.replace("/my-courses");
        } else {
          window.location.replace("/payment/" + res[0].id);
        }
      } else {
        window.location.replace("/Payment");
      }
    } else {
      SaveUserEvent({
        payload: {
          session: user && user.SessionId,
          page: window.location.pathname,
          action: "CourseDetails-registerclicked-notloggedin",
        },
      });
      sessionStorage.setItem("next", "/course/" + course_url + "/" + mode);
      window.location.replace("/login");
    }
  };

  // const LearningObjectives = () => {
  //   const objectives = [
  //     "Acquire technical skills, including HTML, CSS, JavaScript, and relevant programming languages.",
  //     "Develop and complete web development projects and interactive applications.",
  //     "Enhance problem-solving abilities, including debugging and troubleshooting code.",
  //     "Master both front-end and back-end development concepts.",
  //     "Apply industry best practices, such as responsive design and accessibility."
  //   ];}
  return (
    <div style={{ fontFamily: "Poppins, Segoe UI, sans-serif", }}>
      {!course ? (
        <CourseDetailsLoadingTemplate />
      ) : (
        <>
          {/* ===== HERO SECTION (LAYFAX DESIGN) ===== */}
          <Container className="sm-mt-3 lg-mt-0">
            <Row className="align-items-center">
              <Col md={7}>


                <h1 style={{ color: "#080808", fontWeight: 800 }}>
                  {course.course_title}
                </h1>
                <div className="mb-2">
                  <Rating value={course.rating} readOnly />
                  <span className="ms-2 fw-bold">
                    {course.rating} ({course.ratings} reviews)
                  </span>
                </div>

                <p className="text-muted fs-5">
                  {course.description}
                </p>
                <div className="d-flex flex-column gap-2">
                  <div className="d-flex align-items-center gap-2">
                    <span style={{ color: logoOrange, fontSize: '1.5rem', fontWeight: 'bold' }}>✔</span>
                    <span style={{ fontWeight: 600, fontSize: '0.95rem', color: '#000' }}>Comprehensive Curriculum</span>

                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <span style={{ color: logoOrange, fontSize: '1.5rem', fontWeight: 'bold' }}>✔</span>
                    <span style={{ fontWeight: 600, fontSize: '0.95rem', color: '#000' }}>Expert Instructors</span>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <span style={{ color: logoOrange, fontSize: '1.5rem', fontWeight: 'bold' }}>✔</span>
                    <span style={{ fontWeight: 600, fontSize: '0.95rem', color: '#000' }}>Hands-on Projects</span>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <span style={{ color: logoOrange, fontSize: '1.5rem', fontWeight: 'bold' }}>✔</span>
                    <span style={{ fontWeight: 600, fontSize: '0.95rem', color: '#000' }}>Career-Ready Skills</span>
                  </div>
                </div>

                <style>{`
                  @media (max-width: 768px) {
                    .enroll-btn {
                      padding: 0.5rem 1.2rem !important;
                      font-size: 0.85rem !important;
                    }
                    .seats-btn {
                      padding: 0.4rem 0.8rem !important;
                      font-size: 0.9rem !important;
                    }
                    .seats-btn svg {
                      font-size: 20px !important;
                      margin-right: 4px !important;
                    }
                  }
                  @media (max-width: 576px) {
                    .enroll-btn {
                      padding: 0.4rem 1rem !important;
                      font-size: 0.75rem !important;
                      margin-right: 4px !important;
                    }
                    .seats-btn {
                      padding: 0.35rem 0.6rem !important;
                      font-size: 0.8rem !important;
                      margin-left: 4px !important;
                      margin-top: 0 !important;
                    }
                    .seats-btn svg {
                      font-size: 18px !important;
                      margin-right: 2px !important;
                    }
                  }
                `}</style>

                <div className="d-flex gap-2 mt-2">
                  <Button
                    variant="outline-light"

                    style={{
                    background: "linear-gradient(90deg, #f68139, #ff9960)",
                      color: '#fff',
                      border: 'none',

                      fontWeight: 700,
                      fontSize: '1.05rem',
                      borderRadius: '0.4rem',
                      boxShadow: '0 4px 16px #F28C3880',
                      padding: '0.7rem 2.2rem',
                      marginRight: 12,
                    }}
                    className="me-2 text-decoration-none enroll-btn"
                    onClick={NewRegisterCourse}
                    disabled={registering}
                  >
                    {registering ? "Processing..." : "Enroll Now"}
                  </Button>

                  <Button initial={{ scale: 0.9, opacity: 0 }}
                    animate={{ scale: 1.1, opacity: 1 }}
                    transition={{ duration: 0.5, type: 'spring' }}
                    className="seats-btn"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                   background: "linear-gradient(90deg, #f68139, #ff9960)",
                      color: '#fff',
                      fontWeight: 700,
                      border: 'none',

                      fontSize: '1.15rem',
                      borderRadius: '0.7rem',
                      padding: '0.5rem 1.2rem',
                      boxShadow: '0 2px 12px #F28C3880',
                      marginLeft: 12,
                      marginTop: 4,
                      letterSpacing: 1,
                    }}>
                    <GroupIcon style={{ marginRight: 8, fontSize: 28, color: '#fff', filter: 'drop-shadow(0 2px 8px #F28C3880)' }} />

                    {course.seats_left} seats left
                  </Button>
                </div>
              </Col>

              <Col md={5}>
                <Card className="shadow border-0 rounded-4 p-1">
                  <Card.Img src={course.course_cover_url} />
                  <Card.Body>
                    <div className="d-flex justify-content-between">
                      <span>
                        Next Batch:
                        <b className="text-danger ms-1">
                          {dateFormat(course.batch1_starts, "dS mmmm yyyy")}
                        </b>
                      </span>
                      <span>
                        Offer Ends:
                        <b className="text-danger ms-1">
                          {dateFormat(course.offer_ends, "dS mmmm")}
                        </b>
                      </span>
                    </div>

                    {/* <h4 style={{ textAlign: "left" }} className="mt-3 text-primary">
                       {PriceFormat(course.course_price)}
                      <s className="text-danger ms-2">
                        ₹ {PriceFormat(course.course_cutoff_price)}
                      </s>
                    </h4> */}

                    <p className="mt-2 text-start ">
                      <Verified className="text-primary text-start" /> 7 Days Money Back Guarantee
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>

          {/* ===== STACK + OBJECTIVES (LAYFAX DESIGN) ===== */}
          <Container className="mt-5">
        
              {/* <Col md={6}>
              
                    <h3 className="prime-title-feature text-dark secondary-text text-start fs-2">
      Learning   <span className="premium-gradient-text">Objectives</span>
        </h3>
                <ul>
                  {course.objectives
                    ? JSON.parse(course.objectives).map((o, i) => (
                      <li key={i}>{o}</li>
                    ))
                    : <>

                      <li>Acquire technical skills, including HTML, CSS, JavaScript, and relevant programming languages.</li>
                      <li>Develop and complete web development projects and interactive applications..</li>
                      <li>Enhance problem-solving abilities, including debugging and troubleshooting code..</li>
                      <li>Master both front-end and back-end development concepts.</li>
                      <li>Apply industry best practices, such as responsive design and accessibility.</li>

                    </>

                  }

                </ul>
              </Col> */}

              <Col md={12}>
                {/* <h4 className="fs-2" style={{ color: "#161614", fontWeight: 700 }}>Objectives</h4> */}
                
                {/* <div className="d-flex flex-wrap gap-2">
                  {course.stack
                    ? JSON.parse(course.stack).map((tech, i) => (
                      <Button
                        key={i}
                        size="sm"
                        variant="outline-warning"
                        style={{ borderRadius: 20 }}
                      >
                        {tech}
                      </Button>
                    ))
                    : <Button

                      variant="outline-light"
                      style={{
                        borderColor: "#F28C38",
                        //    background: 'linear-gradient(90deg, #F28C38 10%, #FFD580 100%)',
                        color: '#F28C38',
                        fontWeight: 600,
                        borderRadius: '0.5rem',
                        fontSize: '0.98rem',
                        padding: '0.45rem 1.2rem',
                        transition: 'all 0.2s',
                        marginBottom: 4,
                      }}
                    >
                      No specific stack listed for this course.
                    </Button>}
                </div> */}

                <div className="d-flex flex-wrap justify-content-center gap-3 mt-3">
                  <span style={{ fontWeight: "bold", color: "#232526" }} className="fs-6 "><School style={{ color: "#F28C38" }} /> {course.total_enrolled} Total Enrolled</span>
                  <span style={{ fontWeight: "bold", color: "#232526" }} className="fs-6 "><HourglassTop style={{ color: "#F28C38" }} />  Full-Time: 12 weeks

                  </span>
                  <span style={{ fontWeight: "bold", color: "#232526" }} className="fs-6 "><Group style={{ color: "#F28C38" }} /> {course.seats_left}  Seats Free</span>
                  <span style={{ fontWeight: "bold", color: "#232526" }} className="fs-6 "><SignalCellularAlt style={{ color: "#F28C38" }} />  All levels</span>
                  <span style={{ fontWeight: "bold", color: "#232526" }} className="fs-6 "><CardMembership style={{ color: "#F28C38" }} />  Completion Certificate</span>
                </div>
              </Col>
            
          </Container>

          {/* ===== COURSE OVERVIEW / SYLLABUS ===== */}
          <Container className="mt-5" ref={syllabussection}>
            
            {/* <h2 className="text-center fw-bold" style={{ color: "#00A1E4" }}>
      
            </h2> */}
                           <h3 className="prime-title-feature text-dark secondary-text fs-2 text-center">
       Course  <span className="premium-gradient-text">  Overview</span>
        </h3>
            <h5 className="text-center">
              Learn from expertly crafted content designed by industry professionals
            </h5>

            {chapters && (
              <div className="mt-4">
                <SyllabusAccordion chapters={chapters} mode={mode} />
              </div>
            )}
          </Container>

          {/* ===== CERTIFICATE SECTION ===== */}
          <Container className="mt-5 shadow-0 shadow-none" ref={certificatesection}>
            <Row className=" shadow-none rounded-4 shadow-0 bg-white px-5 py-5 border border-1">
              <Col md={6}>
                <h4 className="fs-3" style={{ color: "#F28C38", fontWeight: 740 }}>
                  Earn Your Certificate
                </h4>
                <p className="fs-5 text-bold">
                  Upon successful completion, you will receive a professional
                  certificate that validates your skills.
                </p>
                <ul>
                  <li className="fs-6 text-bold mt-1">Digital & printable certificate</li>
                  <li className="fs-6 text-bold mt-1">Shareable on LinkedIn</li>
                  <li className="fs-6 text-bold mt-1">Signed by instructors</li>
                  <li className="fs-6 text-bold mt-1">Lifetime validity</li>
                </ul>
              </Col>
              <Col md={6}>
                <img
                  src={course.demo_certificate}
                  alt="Certificate"
                  className="img-fluid shadow rounded"
                />
              </Col>
            </Row>
          </Container>

          {/* ===== PROJECTS ===== */}
          {/* <Container className="mt-5" ref={projectssection}>
            <h2 className="text-center fw-bold" style={{ color: "#00A1E4" }}>
              Course Projects
            </h2>
                                       <h3 className="prime-title-feature text-dark secondary-text fs-2 text-center">
       Course  <span className="premium-gradient-text"> Projects</span>
        </h3>

            <Row className="g-4 mt-3">
              {projects &&
                projects.map((p, i) => (
                  <Col md={6} key={i}>
                    <Card className="h-100 shadow-sm border-0">
                      <Row className="g-0">
                        <Col xs={4}>
                          <img
                            src={p.image}
                            className="img-fluid h-100"
                            style={{ objectFit: "cover" }}
                          />
                        </Col>
                        <Col xs={8}>
                          <Card.Body>
                            <h6 className="text-start" style={{ color: "#F28C38", fontWeight: 720 }}>
                              {p.title}
                            </h6>
                            <p className="text-start pt-1 small fs-6">{p.description}</p>
                          </Card.Body>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                ))}
            </Row>
          </Container> */}

          {/* ===== FEATURES ===== */}
          <div ref={featuressection} className="mt-5">
            <FeaturesList mode={mode} course={course} />
          </div>

          {/* ===== SUCCESS STORIES ===== */}
          <div className="container mt-0">
              {/* <SuccessStories /> */}
              {/* <div className="header-desc">
                <h6 className='clr-siliconMinds-orng text-center'>Learn, Grow, and Connect with Experts</h6>
              </div> */}
              <div className="header-title">
                <h1>Our students work at leading companies</h1>
                <img src={Borderline} alt="borderline" className="borderline-img" />
              </div>
            {/* <SuccessStories /> */}
            <Placements />
          </div>

          {/* ===== REVIEWS ===== */}
          {/* <div ref={reviewssection} className="mt-5">
            <Reviews2 course={course} />
          </div> */}

<div>
              <HackingReview />
            </div>

          {/* ===== CONTACT ===== */}
          <div ref={contactsection} className="mt-0">
            <ContactSection />
          </div>

          {/* ===== MOBILE BOTTOM BAR ===== */}
          <div
            className="d-md-none position-fixed bottom-0 w-100 bg-white shadow px-3 py-2 d-flex justify-content-between align-items-center"
            style={{ zIndex: 2000 }}
          >
            <div>
              {/* <b style={{ color: "#00A1E4" }}>
                ₹ {PriceFormat(course.course_price)}
              </b>
              <br />
              <small className="text-muted">
                {course.seats_left} seats left
              </small> */}
            </div>

            <Button
              size="sm"
              style={{
                background: "#F28C38",
                border: "none",
                fontWeight: 600,
              }}
              onClick={NewRegisterCourse}
              disabled={registering}
            >
              {registering ? "Processing..." : "Enroll"}
            </Button>
          </div>

        </>
      )}
    </div>
  );
};

export default CourseDetails1;